import { Save } from 'lucide-react';

const Settings = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-slate-900">General Settings</h1>
        <button className="bg-orange-600 text-white px-4 py-2 rounded flex items-center hover:bg-orange-700 transition-colors">
          <Save size={18} className="mr-2" /> Save Changes
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-slate-100 p-6 space-y-8">
        {/* General Info */}
        <div>
          <h3 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">Website Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Website Title</label>
              <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="Carlos Elec. Industries" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Contact Email</label>
              <input type="email" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="info@carlosindustries.com" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Phone Number</label>
              <input type="tel" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="+1 (555) 123-4567" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Address</label>
              <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="123 Industrial Zone, Tech City" />
            </div>
          </div>
        </div>

        {/* SEO */}
        <div>
          <h3 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">Global SEO</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Meta Title</label>
              <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="Carlos Elec. Industries - High Quality Electrical Components" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Meta Description</label>
              <textarea rows={3} className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="Leading manufacturer of industrial capacitors, regulators, and electronic components." />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
